import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar'; 
import { useLocation, Link } from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';


const Ajouter_utilisateur_diffusion = ({titre}) => {
    useAuth()
    const [diffusionUsers, setDiffusionUsers] = useState([]); 
    const [allUsers, setAllUsers] = useState([]); 
    const [selectedDiffusionUsers, setSelectedDiffusionUsers] = useState([]);
    const [selectedAllUsers, setSelectedAllUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [searchDiffusion, setSearchDiffusion] = useState('');
    const [searchAll, setSearchAll] = useState('');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [alert, setAlert] = useState({ message: '', type: '' });


    const user_id = localStorage.getItem('user_id');
    const { listediffusion_id } = location.state || {};;

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
      if (user_id) {
        document.title = "eTrainApp | Mise en diffusion"; // Définit le titre de la page
      }
    }, [user_id]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE+`/afficher-utilisateurs-de-liste-diffusion/${listediffusion_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setDiffusionUsers(data.utilisateurs_de_liste_diffusion);
                    setAllUsers(data.tous_utilisateurs);
                } else {
                    console.error('Erreur lors de la récupération des utilisateurs');
                }
            } catch (error) {
                console.error('Erreur:', error);
            }
        };
        fetchUsers();
    }, [listediffusion_id]);

    const ajouterTous = () => {
        setDiffusionUsers([...diffusionUsers, ...allUsers]);
        setAllUsers([]);
    };

    const ajouterSelection = () => {
        const selectedUsers = allUsers.filter(user => selectedAllUsers.includes(user.id));
        setDiffusionUsers([...diffusionUsers, ...selectedUsers]);
        setAllUsers(allUsers.filter(user => !selectedAllUsers.includes(user.id)));
        setSelectedAllUsers([]);
    };
    
    const retirerSelection = () => {
        const selectedUsers = diffusionUsers.filter(user => selectedDiffusionUsers.includes(user.id));
        setAllUsers([...allUsers, ...selectedUsers]);
        setDiffusionUsers(diffusionUsers.filter(user => !selectedDiffusionUsers.includes(user.id)));
        setSelectedDiffusionUsers([]);
    };
    
    const retirerTous = () => {
        setAllUsers([...allUsers, ...diffusionUsers]);
        setDiffusionUsers([]);
    };
    
    const handleSubmit = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE+`/enregistrer-utilisateurs-liste-diffusion/${listediffusion_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    utilisateurs_ids: diffusionUsers.map(user => user.id)
                }),
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const responseData = await response.json();
                console.log('Succès:', responseData);
                //showMessage('Les utilisateurs ont été enregistrés avec succès.');
                showAlert('Les utilisateurs ont été enregistrés avec succès.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showMessage('Erreur lors de l\'enregistrement des utilisateurs.');
        }
    };
    

    const [diffusionData, setDiffusionData] = useState({
        nom: '',
        description: '',
        acces: '',
        ajoute_par: '',
        statut: 'inactif',  // Initialisation du statut
    });
    
    // Utilisation de useEffect pour récupérer les données de la diffusion
    useEffect(() => {
        const fetchDiffusionData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE+`/liste-diffusion-info/${listediffusion_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setDiffusionData({
                        id: data.id,
                        nom: data.nom,
                        description: data.description,
                        ajoute_par: data.ajoute_par,
                        statut: data.statut,
                    });
                } else {
                    console.error('Erreur lors de la récupération des données de la diffusion');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };
    
        fetchDiffusionData();
    }, [listediffusion_id]);
    
    const showMessage = (message) => {
        setModalMessage(message);
        setShowModal(true);
    };
    
    const handleClose = () => setShowModal(false);
    
    // Filtrer les utilisateurs en fonction de la recherche
    const filteredDiffusionUsers = diffusionUsers.filter(user => 
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchDiffusion.toLowerCase())
    );
    
    const filteredAllUsers = allUsers.filter(user => 
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchAll.toLowerCase())
    );
    
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            //fetchUsers();
        }, 3000);
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("ListeDeDiffusion")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                                                                    <Link to="/" className="btn btn-primary">
                                                                                        <i className="fa fa-arrow-left mr-2"></i>
                                                                                        Retour
                                                                                    </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }



    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                    <h2 className="mb-1"><i className="fa fa-rss"></i>Mise en diffusion <b> {diffusionData.nom} </b></h2>
                        <small>Administration des diffusions.</small>

                        <small id='hbreadcrumb' className='d-flex justify-content-end'>
                            <ol className="breadcrumb custom-breadcrumb">
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                {/* Utiliser Link de react-router-dom pour la navigation */}
                                <Link to={`/admin`}> Administration</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                {/* Utiliser Link de react-router-dom pour la navigation */}
                                <Link to={`/Liste-diffusion`}> Listes de Diffusion</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                {/* Utiliser Link de react-router-dom pour la navigation */}
                                <Link> Mise en diffusion <b> {diffusionData.nom} </b></Link>
                                </li>
                            </ol>
                        </small>
                    </div>
                </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    {/* <Header titre="Diffusions" sous_titre="Dashboard" sous_titre1="Diffusions" entete={`Ajouter utilisateur au Diffusion ${DiffusionData.nom}`} user_id={user_id} /> */}
                    <div className="container mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="row justify-content-center">

                                <div className="col-md-4">
                                    <h5>Utilisateurs disponibles</h5>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Rechercher..." 
                                        value={searchAll} 
                                        onChange={(e) => setSearchAll(e.target.value)} 
                                        className="mb-3"
                                    />
                                    <select
                                        multiple
                                        value={selectedAllUsers}
                                        onChange={(e) => setSelectedAllUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                        className="form-control"
                                        style={{
                                            height: '320px',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            color: '#333',
                                            fontSize: '16px',
                                            marginBottom: '20px',
                                        }}
                                    >
                                        {filteredAllUsers.map(user => (
                                            <option key={user.id} value={user.id}>
                                                {user.nom} {user.prenoms}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-2 d-flex flex-column justify-content-center">
                                    <button onClick={ajouterTous} className="btn btn-dark mb-2">
                                        {"Ajouter tous >>"}
                                    </button>
                                    <button onClick={ajouterSelection} className="btn btn-dark mb-2">
                                        {"Ajouter sélection >"}
                                    </button>
                                    <button onClick={retirerSelection} className="btn btn-dark mb-2">
                                        {"< Retirer sélection"}
                                    </button>
                                    <button onClick={retirerTous} className="btn btn-dark">
                                        {"<< Retirer tous"}
                                    </button>
                                </div>

                                <div className="col-md-4">
                                    <h5>Utilisateurs de la diffusion</h5>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Rechercher..." 
                                        value={searchDiffusion} 
                                        onChange={(e) => setSearchDiffusion(e.target.value)} 
                                        className="mb-3"
                                    />
                                    <select
                                        multiple
                                        value={selectedDiffusionUsers}
                                        onChange={(e) => setSelectedDiffusionUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                        className="form-control"
                                        style={{
                                            height: '320px',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            color: '#333',
                                            fontSize: '16px',
                                            marginBottom: '20px',
                                        }}
                                    >
                                        {filteredDiffusionUsers.map(user => (
                                            <option key={user.id} value={user.id}>
                                                {user.nom} {user.prenoms}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                            </div>

                            <div className="text-center mt-4">
                                <button onClick={handleSubmit} className="btn btn-success">
                                    Enregistrer les modifications
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de message */}
            {/* <Modal show={showModal} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal> */}
        </div>
    );
};

export default Ajouter_utilisateur_diffusion;
